<template>
  <section id="say">
    <v-container>
      <div
        data-aos-duration="1500"
        data-aos="fade-down"
        class="
          mb-12
          text-h4 text-sm-h3
          font-weight-bold
          error--text
          text-center text--darken-3
        "
      >
        رأيك يهمنا
      </div>
      <!-- form -->
      <v-card
        max-width="500"
        class="mx-auto pa-3 text-center"
        color="transparent"
        flat
      >
        <v-text-field outlined label="اسمك" background-color="white" />
        <v-textarea
          hide-details
          outlined
          label="اكتب رايك عن الشركة"
          background-color="white"
        />
        <v-card-actions class="justify-center mt-3">
          <v-btn block rounded large color="indigo" depressed dark>
            <span>ارسال</span>
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- result -->
      <Carousel />
      <!--  -->
      <section id="say-result" class="mt-12 d-none">
        <v-row v-for="(item, itemInd) in opinions" :key="itemInd">
          <v-col cols="12">
            <v-card width="100%" class="pa-1" flat color="transparent">
              <div class="card-body d-flex align-center">
                <div class="avatar">
                  <!-- <div class="avatar-border"> -->
                  <v-avatar size="70" color="transparent">
                    <v-img src="@/assets/imgs/ESay/person.png" contain />
                  </v-avatar>
                  <!-- </div> -->
                </div>
                <div class="say-content fill-width mr-3">
                  <div class="border pa-2">
                    <div
                      class="
                        person-name
                        mb-3
                        text-body-2 text-sm-h6
                        font-weight-bold
                      "
                    >
                      <!-- black--text -->
                      {{ item.name }}
                    </div>
                    <div
                      class="
                        person-say
                        text-body-2 text-sm-h6
                        font-weight-medium
                        black--text
                      "
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </section>
</template>

<script>
import Carousel from "./ESayCarousel.vue";
export default {
  data: () => ({
    opinions: [
      {
        name: "محمد التهامي",
        title: "شركه محترمة ولها سابقة اعمال تحترم",
      },
      {
        name: "محمود جريشة",
        title: "شركة محترمه اوصي التعامل معها",
      },
      {
        name: "محمد حسين النبوي",
        title: "شركة جودة العمل جيدة ولها سابقة اعمال محترمة",
      },
      {
        name: "محمد علي",
        title: "شغل تمام الله ينور",
      },
    ],
  }),
  components: {
    Carousel,
  },
};
</script>

<style lang="scss" scoped>
.avatar-border {
  border: 2px solid black;
  border-radius: 50%;
}
.border {
  border: 1px solid black;
}
</style>